import React from 'lib/react';
import {
  EVGrid,
  EVSkeleton,
} from 'lib/components';
import SubscriptionInformationStyles from './SubscriptionInformationStyles';

function SubscriptionInformationLoader() {
  const classes = SubscriptionInformationStyles();

  return (
    <EVGrid className={classes.subscriptionsContainer}>
      {/* Current Period Skeleton */}
      <EVGrid className={classes.currentPeriodContainer}>
        <EVSkeleton style={{ height: '36px', width: '20%', borderRadius: '6px' }} animation="wave" variant="rect" />
        <EVSkeleton style={{ height: '24px', width: '25%', borderRadius: '6px' }} animation="wave" variant="rect" />
      </EVGrid>

      <EVGrid className={classes.subscriptionsAndSummaryContainer}>
        {/* Subscription Cards Skeleton */}
        <EVGrid className={classes.subscriptionCardsContainer}>
          {[1, 2].map((index) => (
            <EVGrid
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '16px',
                borderRadius: '16px',
                border: '1px solid #E0E0E0',
                flex: '1 1 100%',
                height: '140px',
                gap: '12px',
                justifyContent: 'space-between',
              }}
              className="subscription-card-loader"
            >
              {/* Top section with icon and details */}
              <EVGrid style={{ display: 'flex', gap: '16px' }}>
                <EVSkeleton style={{ height: '60px', width: '60px', borderRadius: '8px' }} animation="wave" variant="rect" />
                <EVGrid style={{
                  display: 'flex', flexDirection: 'column', gap: '8px', flex: 1,
                }}
                >
                  <EVSkeleton style={{ height: '20px', width: '70%', borderRadius: '6px' }} animation="wave" variant="rect" />
                  <EVGrid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <EVSkeleton style={{ height: '18px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
                    <EVGrid style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <EVSkeleton style={{ height: '16px', width: '100px', borderRadius: '6px' }} animation="wave" variant="rect" />
                      <EVSkeleton style={{ height: '16px', width: '100px', borderRadius: '6px' }} animation="wave" variant="rect" />
                    </EVGrid>
                  </EVGrid>
                </EVGrid>
              </EVGrid>

              {/* Bottom section with progress bar */}
              <EVGrid style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <EVGrid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <EVSkeleton style={{ height: '18px', width: '25%', borderRadius: '6px' }} animation="wave" variant="rect" />
                  <EVSkeleton style={{ height: '18px', width: '20%', borderRadius: '6px' }} animation="wave" variant="rect" />
                </EVGrid>
                <EVSkeleton style={{ height: '4px', width: '100%', borderRadius: '2px' }} animation="wave" variant="rect" />
              </EVGrid>
            </EVGrid>
          ))}
        </EVGrid>

        {/* Summary Section Skeleton */}
        <EVGrid className={classes.summaryPaper}>
          <EVGrid className={classes.summaryContent}>
            {[1, 2, 3, 4, 5].map((index) => (
              <EVGrid key={index} className={classes.summaryRow}>
                <EVSkeleton style={{ height: '18px', width: '50%', borderRadius: '6px' }} animation="wave" variant="rect" />
                <EVSkeleton style={{ height: '24px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
              </EVGrid>
            ))}
            <EVGrid className={classes.summaryDivider} />
            <EVGrid className={classes.summaryRow}>
              <EVSkeleton style={{ height: '20px', width: '70%', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '28px', width: '35%', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

export default SubscriptionInformationLoader;
